import { Modal } from "@website/ui/modal";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { Login } from "@website/widget/login/login";
import { useLoginModal } from "@website/widget/login/use-login-modal";

export const LoginModal = () => {
  const { loginModalProps, onLoginModalClose, onLoginModalEnd } =
    useLoginModal();
  const router = useCompatRouter();
  const { isWelcomeScreen } = (router?.query ?? {}) as Record<string, string>;
  return (
    <Modal className="scroll-mt-[100px]" {...loginModalProps} usePortal>
      <Login
        onClose={onLoginModalClose}
        onEndAuth={onLoginModalEnd}
        isWelcomeScreen={Boolean(isWelcomeScreen)}
      />
    </Modal>
  );
};
